/**
 * Icons displayed in the header of the order
 */

import { html } from 'lit';

/**
 * Icons when an order is loading / fails to load
 */

export const LoadingIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M280-420q25 0 42.5-17.5T340-480q0-25-17.5-42.5T280-540q-25 0-42.5 17.5T220-480q0 25 17.5 42.5T280-420Zm200 0q25 0 42.5-17.5T540-480q0-25-17.5-42.5T480-540q-25 0-42.5 17.5T420-480q0 25 17.5 42.5T480-420Zm200 0q25 0 42.5-17.5T740-480q0-25-17.5-42.5T680-540q-25 0-42.5 17.5T620-480q0 25 17.5 42.5T680-420ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
    />
  </svg>
`;

export const ErrorIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm0 200q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Z"
    />
  </svg>
`;

/**
 * Icons when an order is succcesfuly loaded
 */

export const PendingIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M480-140q-29.83 0-51.07-21.24-21.24-21.24-21.24-51.07v-565.15q0-21.31 11.66-39.08 11.65-17.77 31.34-26.61l113.46-49.69q36.54-15.85 68.89 5.92 32.34 21.77 32.34 60.77v6.15h122.31q29.83 0 51.07 21.24Q860-777.52 860-747.69v535.38q0 29.83-21.24 51.07Q817.52-140 787.69-140H480Zm-12.31-95.61L598.08-293q3.07-1.54 5.19-4.62 2.12-3.07 2.12-6.92v-521.61q0-6.54-5.58-10.2-5.58-3.65-11.73-.96L475-788q-3.08 1.54-5.19 4.62-2.12 3.07-2.12 6.92v540.85Zm72.77 33.69q.77.77 2.11 1.34 1.35.58 3.27.58h241.85q5.39 0 8.85-3.46t3.46-8.85v-535.38q0-5.39-3.46-8.85t-8.85-3.46H665.38v455.46q0 22.46-12.03 40.65-12.04 18.2-30.2 25.66l-82.69 36.31ZM100-755.38V-820h64.62v64.62H100ZM100-140v-64.62h64.62V-140H100Zm0-153.85v-64.61h64.62v64.61H100Zm0-153.84v-64.62h64.62v64.62H100Zm0-153.85v-64.61h64.62v64.61H100Zm153.85-153.84V-820h64.61v64.62h-64.61Zm0 615.38v-64.62h64.61V-140h-64.61Zm213.84-95.61v-549.31 549.31Z"
    />
  </svg>
`;

export const ReceivedIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M620-220v84.61q0 14.7-10.35 25.04Q599.31-100 584.61-100H135.39q-14.7 0-25.04-10.35Q100-120.69 100-135.39v-289.22q0-14.7 10.35-25.04Q120.69-460 135.39-460H260v-180q0-91.54 64.23-155.77T480-860h160q91.54 0 155.77 64.23T860-640v540h-60v-120H620Zm0-60h180v-360q0-66-47-113t-113-47H480q-66 0-113 47t-47 113v180h264.61q14.7 0 25.04 10.35Q620-439.31 620-424.61V-280ZM410-570v-60h300v60H410Zm-50 284 200-114H160l200 114Zm0 55.38-200-114V-160h400v-184.62l-200 114ZM160-400v240-240Z"
    />
  </svg>
`;

export const ProcessingIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M420-55.39V-140H212.31Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21H420v-84.61h60v849.22h-60ZM200-240h220v-263.85L200-240Zm360 100v-340l200 240v-507.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H560v-60h187.69Q778-820 799-799q21 21 21 51.31v535.38Q820-182 799-161q-21 21-51.31 21H560Z"
    />
  </svg>
`;

export const CompletedIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 -960 960 960"
  >
    <path
      d="M562-238.85 746.77-424 704-466.15l-142 142-56.38-56.62L462.85-338zM290-370h100v-60H290zm0-120h260v-60H290zm0-120h260v-60H290zm190.07 510q-78.84 0-148.21-29.92t-120.68-81.21-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68-120.63 81.25Q558.9-100 480.07-100m-.07-60q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"
    />
  </svg>
`;

export const PaidIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M172.31-100Q142-100 121-121q-21-21-21-51.31v-455.38Q100-658 121-679q21-21 51.31-21h165.38L480-842.3 622.31-700h165.38Q818-700 839-679q21 21 21 51.31v455.38Q860-142 839-121q-21 21-51.31 21H172.31Zm0-60h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM270-250h423.07L561.54-425.38 449.23-279.23l-80-102.31L270-250Zm418.46-190q21.92 0 37.12-15.19 15.19-15.19 15.19-37.12 0-21.92-15.19-37.11-15.2-15.19-37.12-15.19-21.92 0-37.11 15.19-15.2 15.19-15.2 37.11 0 21.93 15.2 37.12Q666.54-440 688.46-440ZM404.77-700h150.46L480-775.23 404.77-700ZM160-160v-480 480Z"
    />
  </svg>
`;

export const CancelledIcon = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M172.31-100Q142-100 121-121q-21-21-21-51.31v-455.38Q100-658 121-679q21-21 51.31-21h165.38L480-842.3 622.31-700h165.38Q818-700 839-679q21 21 21 51.31v455.38Q860-142 839-121q-21 21-51.31 21H172.31Zm0-60h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM270-250h423.07L561.54-425.38 449.23-279.23l-80-102.31L270-250Zm418.46-190q21.92 0 37.12-15.19 15.19-15.19 15.19-37.12 0-21.92-15.19-37.11-15.2-15.19-37.12-15.19-21.92 0-37.11 15.19-15.2 15.19-15.2 37.11 0 21.93 15.2 37.12Q666.54-440 688.46-440ZM404.77-700h150.46L480-775.23 404.77-700ZM160-160v-480 480Z"
    />
  </svg>
`;
